import clsx from 'clsx'
import React, { useEffect } from 'react'

import styles from './BackgroundTitle.module.scss'

interface Props {
  title: string
  initialFontSize: string
  strokeColor?: string
  children?: React.ReactNode
  className?: string
}

const BackgroundTitle = ({ title, initialFontSize, strokeColor, children, className }: Props) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth)
  const [fontSize, setFontSize] = React.useState<string | undefined>(initialFontSize)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const fontSize = function () {
      if (initialFontSize && windowWidth) {
        if (windowWidth >= 1920) setWindowWidth(1920)
        return (Number(initialFontSize.replace('px', '')) * windowWidth) / 1440 + 'px'
      }
      return undefined
    }

    if (fontSize()) setFontSize(fontSize())
  }, [windowWidth, initialFontSize])

  return (
    <div
      className={clsx(styles.backgroundTitleContainer, className)}
      style={{ fontSize: fontSize, lineHeight: fontSize, WebkitTextStrokeColor: strokeColor }}
    >
      <p>{title}</p>
      {children}
    </div>
  )
}

export default BackgroundTitle
